import React from 'react';
import classes from './NavigationItems.module.css';
import NavigationItem from './NavigationItem/NavigationItem';

const NavigationItems = (props) => (
    <ul className={classes.NavigationItems}>
        {props.shouldShowOtherLinks ? 
            <React.Fragment>
                <NavigationItem link="/burgerBuilder">Burger Builder</NavigationItem>
                <NavigationItem link="/orders" icon="list">Orders</NavigationItem>
                <NavigationItem link="/checkout" icon="shopping_cart">Checkout</NavigationItem>
                <NavigationItem link="/logout">Logout</NavigationItem>
            </React.Fragment> : 
             <NavigationItem link="/login">Login</NavigationItem>
    }
    </ul>
);

export default NavigationItems;